<script>
import OwTable from '@/components/common/OwTable';
import TableRow from '@/components/cups/TableRow';

export default {
    name: 'CupsTable',
    extends: OwTable,
    props: {
        headers: {
            type: Array,
            default: () => [
                'name', 'course', 'starting_at', 'ending_at', 'player_count',
            ],
        },
        tableRowComponent: {
            type: Object,
            default: () => TableRow,
        },
    },
};
</script>
